import * as React from "react";
const SvgPlay = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...props },
    React.createElement("path", { fill: "currentColor", d: "M20 12 8 20V4z" })));
export default SvgPlay;
//# sourceMappingURL=Play.js.map